import React from "react";

function BillsPage() {
  return <div>BillsPage</div>;
}

export default BillsPage;
